import styled from "styled-components";

const IconImage = styled.img`
  width: 24px;
  height: 24px;
  display: flex;
`;

export default IconImage;
